<ng-container *ngIf="showResults">
  <app-results-guided
    [isEmbeddedInQuizResult]="true"
    [embeddedStepsToReview]="stepsToReview"
    (avatarThumbnailReady)="avatarThumbnailReady.emit($event)"
  ></app-results-guided>
</ng-container>
